angular.module('core').filter('narrative', [
  function() {
    var narrativeFilter = function(code, type, name) {
      if( _.isEmpty(code) || _.isUndefined(code) ) {
        return '';
      }

      var getStudentNarrative = function(code) {
        switch (code) {
          case 'LOW_AVERAGE_SESSION_TIME':
            return name + " has played fewer than 15 total minutes in the last seven days. This usage is significantly below the recommended 60 minutes per week.";
          case 'HIGH_AVERAGE_SESSION_TIME':
            return name + " has played for 60 minutes or more in the last seven days. This accomplishment is above the recommended weekly usage!";
          case 'LOW_AVERAGE_LESSONS_COMPLETED':
            return name + " has completed fewer than two lessons in the last seven days. This usage is significantly below the recommended five lessons completed per week.";
          case 'HIGH_AVERAGE_LESSONS_COMPLETED':
            return name + " has completed five or more lessons in the last seven days. This accomplishment is above the recommended weekly usage!";
          case 'FAILED_LESSONS_THRESHOLD_REACHED':
            return name + " was not proficient in three of the last five completed lessons. View the Activity tab to see " + name + "'s recently completed lessons.";
          case 'LESSONS_COMPLETED_LOW_EFFICIENCY':
            return name + " has completed fewer than two lessons in the last seven days. This usage is significantly below the recommended five lessons completed per week.";
          default:
            console.warn('No narrative for code %s', code);
            return '';
        }
      };

      var getNarrative = function(code) {
        switch (code) {
          case 'LOW_AVERAGE_SESSION_TIME':
            return "This " + type + "\'s students have played fewer than 15 minutes on average in the last seven days. This usage is significantly below the recommended 60 minutes per week.";
          case 'HIGH_AVERAGE_SESSION_TIME':
            return "This " + type + "\'s students have played for an average of 60 minutes or more in the last seven days. This accomplishment is above the recommended weekly usage!";
          case 'LOW_AVERAGE_LESSONS_COMPLETED':
            return "This " + type + "\'s students have completed fewer than two lessons on average in the last seven days. This usage is significantly below the recommended five lessons completed per week.";
          case 'HIGH_AVERAGE_LESSONS_COMPLETED':
            return "This " + type + "\'s students have completed five or more lessons on average in the last seven days. This accomplishment is above the recommended weekly usage!";
          case 'LOW_PERCENTAGE_ACTIVE_STUDENTS':
            return "Less than 20% of this " + type + "\'s students used DreamBox in the last seven days";
          case 'HIGH_PERCENTAGE_ACTIVE_STUDENTS':
                return "More than 70% of this " + type + "\'s students used DreamBox in the last seven days";
          // STUDENT ONLY - G2 Should never return anything
          case 'FAILED_LESSONS_THRESHOLD_REACHED':
            return "";
          // STUDENT ONLY - G2 Should never return anything
          case 'LESSONS_COMPLETED_LOW_EFFICIENCY':
            return "";
          default:
            console.warn('No narrative for code %s', code);
            return '';
        }
      };

      return (type === 'student' || type === 'guardian') ? getStudentNarrative(code) : getNarrative(code);

    };

    // Quick hack to indicate if narrative is warning vs accomplishment
    narrativeFilter.isWarning = function (code, type) {
      return narrativeFilter(code, type, '') && code !== 'HIGH_AVERAGE_SESSION_TIME' && code !== 'HIGH_AVERAGE_LESSONS_COMPLETED' && code !== 'HIGH_PERCENTAGE_ACTIVE_STUDENTS';
    };

    return narrativeFilter;
  }
]);


